import {SecurityStore} from "./securityStore";
import {Authentication} from "./authentication";
import {AuthenticationManagerOptions, AuthenticationOptions} from "./typing";
import {Subscribable} from "./subscribable";

export interface AuthenticationManagerState<TPrincipal> {
    isLoading: boolean;
    isPending: boolean;
    isAuthenticated: boolean;
    principal: TPrincipal | undefined;
}
export type AuthenticationManagerListener<TPrincipal> = (state: AuthenticationManagerState<TPrincipal>) => void;
export class AuthenticationManager<TPrincipal = unknown> extends Subscribable<AuthenticationManagerListener<TPrincipal>>{
    store: SecurityStore;
    options: AuthenticationManagerOptions<TPrincipal>;
    isLoading: boolean = false;
    principal: TPrincipal | undefined = undefined;
    authentication: Authentication<any, TPrincipal> | null = null;

    constructor(options: AuthenticationManagerOptions<TPrincipal>) {
        super();
        this.options = options;
        this.store = new SecurityStore();
        const {
            initialPrincipal,
        } = this.options;

        if (initialPrincipal) {
            this.isLoading = true;
            this.updateState();
            initialPrincipal().then((value) => {
                this.initial(value)
            }, (_reason) => {
                this.initial()
            })
        } else {
            this.initial();
        }

    }

    initial(principal?: TPrincipal) {
        this.isLoading = false;
        this.principal = principal;
        this.updateState();
    }

    authenticate<TVariables = void>(_variables: TVariables, options: AuthenticationOptions<TVariables, TPrincipal>): Authentication<TVariables, TPrincipal> {

        const authentication = new Authentication<TVariables, TPrincipal>(options);
        this.authentication = authentication;
        this.updateState();
        authentication.subscribe((state) => {
            // this.onUpdate(state);
            this.principal = state.principal;
            this.updateState();
            if (state.status === 'authenticated') {
                this.options.onSuccess?.(this.principal!);
            }
        })

        // return await authentication.execute(variables);
        return authentication;
    }

    requestAuthenticated(): Promise<void> {
        if (this.isAuthenticated()) {
            return Promise.resolve();
        }
        const authentication = this.authentication;
        if (authentication) {
            return new Promise<void>((resolve, reject) => {
                authentication.subscribe((state) => {
                    if (state.status === 'authenticated') {
                        resolve();
                    }
                    if (state.status === 'error') {
                        reject();
                    }
                });
            })
        }
        return Promise.reject('request unauthenticated');
    }


    isPending(): boolean {
        if (this.authentication) {
            return this.authentication.isPending();
        }
        return false;
    }
    isAuthenticated(): boolean {
        return !!this.principal;
    }
    reset() {
        this.options.onReset?.();
        this.authentication?.destroy();
        this.principal = undefined;
        this.updateState();
    }

    // setAuthenticated(principal: TPrincipal) {
    //     this.principal = principal;
    //     this.updateState();
    // }
    invalidate(): void {
        this.reset();
    }

    state!: AuthenticationManagerState<TPrincipal>;
    updateState() {
        const authenticate = this.authentication;
        this.state = {
            isLoading: this.isLoading,
            isPending: this.isLoading || (authenticate?.isPending()??false),
            isAuthenticated: this.isAuthenticated(),
            principal: this.principal
        }
        this.emit(this.state);
    }
    getCurrentState() {
        return this.state;
    }
    // onUpdate(state: AuthenticationState<TPrincipal>): void {
    //     this.listeners.forEach((listener) => {
    //         listener({
    //             principal: state.principal,
    //         })
    //     })
    //     // if (state.status === 'authenticated') {
    //     //
    //     // }
    // }
}